<section class="project-tab-section">
  <div class="project-tab-section__toolbar">
    <div class="project-tab-section__intro">
      <h2 class="project-tab-section__title">Sources</h2>
      <p class="project-tab-section__subtitle">
        Folders linked to this project. Open a folder to manage sources in Sources.
      </p>
    </div>
    <ng-container *allowedRole="'admin'">
      @if (projectFolders.length) {
        <button
          mat-stroked-button
          color="primary"
          type="button"
          (click)="openAllFoldersListModal()"
        >
          Edit project sources
        </button>
      }
    </ng-container>
  </div>

  @if (projectFolders.length) {
    <ul class="project-source-list">
      @for (folder of projectFolders; track folder._id) {
        <li>
          <button type="button" class="project-source-list__item" (click)="navigateToFolder(folder._id)">
            <mat-icon class="project-source-list__icon" fontSet="material-symbols-outlined">folder_open</mat-icon>
            <span class="project-source-list__name">{{ folder.name }}</span>
            <mat-icon class="project-source-list__chevron" fontSet="material-symbols-outlined">chevron_right</mat-icon>
          </button>
        </li>
      }
    </ul>
  } @else {
    <div class="project-tab-empty">
      <mat-icon class="project-tab-empty__icon" fontSet="material-symbols-outlined">library_books</mat-icon>
      <p class="project-tab-empty__text">
        No sources are assigned to this project yet. Add folders to connect documentation and materials.
      </p>
      <button mat-flat-button color="primary" type="button" (click)="openAllFoldersListModal()">
        Add project sources
      </button>
    </div>
  }
</section>
